// =====================================================
// COMPOSANT: StatisticCard
// Description: Carte réutilisable pour afficher une statistique avec icône
// =====================================================

import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface StatisticCardProps {
  title: string;
  value: string | number;
  description: string;
  icon: LucideIcon;
  onClick?: () => void;
}

/**
 * Carte de statistique avec icône, valeur principale et description
 * Optionnellement cliquable si onClick est fourni
 */
export function StatisticCard({
  title,
  value,
  description,
  icon: Icon,
  onClick,
}: StatisticCardProps) {
  const isClickable = !!onClick;

  return (
    <Card
      className={`border border-zinc-200 ${isClickable ? 'cursor-pointer transition-colors hover:bg-zinc-50 hover:border-zinc-300' : ''}`}
      onClick={onClick}
    >
      <CardContent className="px-6">
        <div className="flex flex-col gap-2">
          {/* Header avec titre et icône */}
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-medium text-zinc-950">{title}</h3>
            <Icon className="h-4 w-4 text-zinc-900" />
          </div>

          {/* Valeur principale */}
          <div className="flex flex-col">
            <p className="text-2xl font-bold text-zinc-950">{value}</p>
            <p className="text-xs text-zinc-500">{description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
